import { render, staticRenderFns } from "./ElementStaticExtra.vue?vue&type=template&id=491f6058"
import script from "./ElementStaticExtra.vue?vue&type=script&lang=ts"
export * from "./ElementStaticExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports